module.exports = __webpack_public_path__ + "static/img/4设计师2.534b3e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/4设计师2.png
// module id = kcPw
// module chunks = 1